import * as React from "react";

import "./qr-route.scss";

import {cs}            from "@Common/react/chain-services";
import {parseUrlQuery} from "@Common/utils/parse-url-query";

export const QRRoute = ({}) =>
{
    return <div>qrious must be installed to test</div>
    /*var QRious = require('qrious'); // requires npm install qrious
    const search = parseUrlQuery(window.location.search)
    return (
        <>
            <canvas id='qr'></canvas>
            {(function() {
                var qr = new QRious({
                    element: document.getElementById('qr'),
                    padding: 2,
                    size: 100,
                    value: search && search['url'] ? (
                        search['url']
                    ) : (
                        "https://www.xpressdocs.com"
                    ),
                });
            })()}
        </>
    )*/
}
